import {useMutation, useQueryClient} from '@tanstack/react-query';
import {UseFormReturn} from 'react-hook-form';
import {apiClient, queryClient} from '@common/http/query-client';
import {toast} from '@common/ui/toast/toast';
import {useTrans} from '@common/i18n/use-trans';
import {onFormQueryError} from '@common/errors/on-form-query-error';
import {message} from '@common/i18n/message';
import {BackendResponse} from '@common/http/backend-response/backend-response';
import {EditorProject} from '@app/dashboard/project';
import {getProductionHtml} from '@app/editor/utils/parse-html-into-document';
import {BLANK_PAGE_SKELETON} from '@app/projects/blank-page-skeleton';
import {BuilderTemplate} from '@app/templates/builder-template';
import {fetchTemplate} from '@app/templates/use-template';
import {reloadAccountUsage} from '@app/editor/use-account-usage';


interface Response extends BackendResponse {
  project: EditorProject;
}

export interface CreateCategoryPayload {
  name: string; 
  project_id: number;
}

export function useCreateCategory(form: UseFormReturn<CreateCategoryPayload>) {
  const {trans} = useTrans();  
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: CreateCategoryPayload) => createCategory(payload),
    onSuccess: async () => {
      reloadAccountUsage();
      await queryClient.invalidateQueries({queryKey: ['categories']});
      toast(trans(message('Category created')));
    },
    onError: err => onFormQueryError(err, form),
  });
}

async function createCategory({
  name,
  project_id
}: CreateCategoryPayload) {
  const payload: {
    name: string;    
    project_id?: string | number;
  } = {
    name,    
    project_id
  };    
  return apiClient.post<Response>('categories/create', payload).then(r => r.data);
}


